module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "unique-opened": true,
      "mode": "vertical",
      "theme": "dark",
      "default-active": _vm.$route.path
    }
  }, [_vm._l((_vm.permission_routers), function(item) {
    return (!item.hidden) ? [(!item.noDropdown) ? _c('el-submenu', {
      attrs: {
        "index": item.name
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('wscn-icon-svg', {
      attrs: {
        "icon-class": item.icon || 'wenzhang1'
      }
    }), _vm._v(" " + _vm._s(item.name) + "\n            ")], 1), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('router-link', {
        key: child.path,
        staticClass: "title-link",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n                    " + _vm._s(child.name) + "\n                ")])], 1) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.noDropdown && item.children.length > 0) ? _c('router-link', {
      attrs: {
        "to": item.path + '/' + item.children[0].path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": item.path + '/' + item.children[0].path
      }
    }, [_c('wscn-icon-svg', {
      attrs: {
        "icon-class": item.icon || 'geren1'
      }
    }), _vm._v(" " + _vm._s(item.children[0].name) + "\n            ")], 1)], 1) : _vm._e()] : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fded3a6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Sidebar.vue
// module id = 280
// module chunks = 30